import { jsx as _jsx } from "react/jsx-runtime";
// @deprecated - This page should not be used and will be deleted after releasing views/ErrorPages/500.tsx
import BaseErrorPage from '../../../views/ErrorPages';
function PageInternalServerError() {
    return (_jsx(BaseErrorPage, { title: "500", subTitle: "Something went wrong", description: 'Sorry, there was an error processing your request. Please try again later. If the issue persists, please contact <a href="https://help.certify.com">customer support</a>' }));
}
export default PageInternalServerError;
